import React, { ReactElement } from 'react';
import { BlurbUtil } from '@hugendubel/blurb';
import { Annotation, Article, CoverImg } from '@hugendubel/article';
import { renderDate } from '@hugendubel/react-basic';

export const _ArticleDetailsView = {
    renderBlurb: (annotations: readonly Annotation[] | undefined): ReactElement | undefined => {
        const blurb = annotations?.find(item => item.annotationType?.code === 'KLAPPENTXT');

        return blurb && blurb.text ? (
            <p className="card-text" dangerouslySetInnerHTML={{ __html: BlurbUtil.sanitize(blurb.text) }} />
        ) : undefined;
    },
    renderShortInfo: (publicationDate: Date | undefined, binderName?: string, pages?: string): string =>
        [publicationDate && renderDate(publicationDate), binderName, pages].filter(Boolean).join(' - '),
};

export type ArticleDetailsViewProps = { article: Article };

export const ArticleDetailsView: React.FC<ArticleDetailsViewProps> = ({ article }) => (
    <div className="clearfix">
        <div className="cover">
            <CoverImg coverPath={article.articleAttributeView?.imgExtraLarge} />
        </div>
        <div className="details">
            <div className="title">{article.articleAttributeView?.title}</div>
            <div className="authors">{article.articleAttributeView?.authorList}</div>
            <div className="info">
                {_ArticleDetailsView.renderShortInfo(
                    article.articleAttributeView?.publicationDate,
                    article.articleAttributeView?.binderName,
                    article.articleAttributeView?.pages
                )}
            </div>
        </div>
        <div className="blurb">{_ArticleDetailsView.renderBlurb(article.articleAnnotations)}</div>
    </div>
);
